import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};
// firebase setup
export const Firebase = firebase.initializeApp(firebaseConfig);
export const firebaseAuth = firebase;

// auth emulator
if (process.env.REACT_APP_EMULATOR_AUTH_URL && process.env.REACT_APP_EMULATOR_AUTH_URL !== '') {
  Firebase.auth().useEmulator(process.env.REACT_APP_EMULATOR_AUTH_URL.toString(), { disableWarnings: true });
}

// database connection
const baseDb = Firebase.firestore();
if (
  process.env.REACT_APP_EMULATOR_URL &&
  process.env.REACT_APP_EMULATOR_PORT &&
  process.env.REACT_APP_EMULATOR_URL !== '' &&
  process.env.REACT_APP_EMULATOR_PORT !== ''
) {
  baseDb.useEmulator(process.env.REACT_APP_EMULATOR_URL.toString(), process.env.REACT_APP_EMULATOR_PORT);
}

// export modules
export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const DB = baseDb;
export const API_URL = process.env.REACT_APP_API_URL;
